import { Component, ElementRef, EventEmitter, HostListener, Input, Output, Renderer2, ViewChild } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { TrapFocusComponent } from 'remarketing-ui-components-lib';
import { FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { UtilityService } from 'smartauction-frontend-micro-library';

@Component({
    selector: 'app-multi-selector-dropdown',
    templateUrl: './multi-selector-dropdown.component.html',
    styleUrls: ['./multi-selector-dropdown.component.scss'],
    imports: [TranslocoDirective, TrapFocusComponent, FormsModule, CommonModule]
})
export class MultiSelectorDropdownComponent {
  @Input() list: any[];
  @Input() isRequired: boolean;
  @Input() multiSelectEnabled: boolean;
  @Output() checkedList = new EventEmitter();
  @ViewChild('checkboxes') checkboxes: ElementRef;

  currentSelected = {};
  showDropDown = false;
  status: boolean;

  componentId = this.utilityService.generateId();

  constructor(private readonly renderer: Renderer2, private readonly utilityService: UtilityService) {}

  // If clicked outside or pressed on escape key, close the dropdown if open
  @HostListener('document:click', ['$event'])
  @HostListener('document:keyup.escape', ['$event'])
  clickout(event) {
    if (this.showDropDown && !document.getElementById('multi-select' + this.componentId).contains(event.target)) {
      this.toggleCheckboxVisibility();
    }
  }

  getSelectedValue(status: boolean, value: string) {
    if (status && !this.multiSelectEnabled) {
      this.clearAllButRecentlySelected(value);
    }

    this.list.forEach(listItem => {
      if (listItem.disclosureDescription === value) {
        listItem.selected = status;
      }
    });

    this.currentSelected = { selected: status, name: value };
    this.checkedList.emit(this.list);
  }

  clearAllButRecentlySelected(recentSelected: string) {
    this.list.forEach(yellowLight => {
      if (yellowLight.disclosureDescription !== recentSelected) {
        yellowLight.selected = false;
        yellowLight.checked = false;
      }
    });
  }

  getSelection() {
    let selection = '';
    if (this.list.some(item => item.selected)) {
      const temp = this.list.filter(item => item.selected).map(item => item.disclosureDescription);
      selection = temp.join(', ');
    } else if (this.list.filter(item => item.selected === false)) {
      selection = 'Select';
    }
    return selection;
  }

  getSelectedItemCount() {
    return this.list.filter(item => item.selected).length;
  }

  toggleCheckboxVisibility() {
    if (!this.showDropDown) {
      this.renderer.setStyle(this.checkboxes.nativeElement, 'display', 'block');
      this.showDropDown = true;
    } else {
      this.renderer.setStyle(this.checkboxes.nativeElement, 'display', 'none');
      this.showDropDown = false;
    }
  }
}
